"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbAsisSessionStorage = exports.MbAsisSession = void 0;
const web_ui_security_1 = require("@gruposantander/web-ui-security");
const storage_1 = require("./storage");
Object.defineProperty(exports, "MbAsisSessionStorage", { enumerable: true, get: function () { return storage_1.MbAsisSessionStorage; } });
class MbAsisSession extends web_ui_security_1.BaseSession {
    constructor(sessionStorage) {
        super(sessionStorage);
        //TODO mismo refresh que MBSession, compartir el código
        this.doRefresh = async () => {
            if (!this.xhr) {
                throw Error('Set xhr before use Session');
            }
            try {
                const actualSessionInfo = {
                    refreshToken: this.getData()?.refreshToken,
                    username: this.getData()?.username,
                };
                //TODO: Logic to make recalls
                const { data: { accessToken, sessionExpiresAt, expiresIn, refreshToken }, } = await this.xhr.POST(`${window.MIDDLEWARE_BASE_HOST}/mb-api-auth/authentication/refresh-token`, actualSessionInfo);
                //TODO: add DDD architecture to avoid endpoints and transformations here
                const newSessionData = {
                    accessToken,
                    sessionExpiresAt: sessionExpiresAt ? new Date(sessionExpiresAt) : null,
                    expiresIn,
                    refreshToken,
                    username: this.getData()?.username || '',
                };
                return Promise.resolve(newSessionData);
            }
            catch (e) {
                this.finishSession();
                throw e;
            }
        };
        this.isDataValid = (sessionData) => {
            if (sessionData.accessToken && sessionData.refreshToken && sessionData.username) {
                return true;
            }
            return false;
        };
        this.xhr = null;
    }
    setXHR(newXhr) {
        this.xhr = newXhr;
    }
}
exports.MbAsisSession = MbAsisSession;
//# sourceMappingURL=index.js.map